import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit {
  @Input() color = 'primary';
  @Input() size = 'md';
  @Input() outline = false;

  constructor() { }

  ngOnInit(): void {
  }

}
